import { Ticket as TicketIcon, Loader2, Camera, Mic } from "lucide-react";
import { Input } from "@/components/ui/input";

// Bloque Ingreso de vehículos — presentacional. Toda la lógica vive en Terminal.jsx.
export const IngresoVehiculos = ({
  fotoIaActiva, vozIaActiva, placaFileRef, placaInputRef, placa, setPlaca,
  onPlacaFoto, dictarPlaca, placaAiLoading, escuchandoPlaca,
  vehiculosDinamicos, vehiculosLegacy, hasPorHora, generarTicket, generando, lleno,
}) => (
  <div className="border border-white/10 bg-white/[0.02] p-5" data-testid="bloque-ingreso">
    <div className="flex items-center gap-2 mb-5">
      <TicketIcon className="h-5 w-5 text-[#FFCC00]" />
      <h2 className="font-display text-xl font-black tracking-tight">Ingreso de vehículos</h2>
    </div>
    <div className="space-y-2 mb-6">
      <div className="flex items-center justify-between gap-2">
        <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-white/60">Placa (opcional)</label>
        <div className="flex items-center gap-1.5">
          {fotoIaActiva && (
            <button type="button" onClick={() => placaFileRef.current?.click()} disabled={placaAiLoading} data-testid="placa-foto-btn" title="Tomar foto de la placa (IA · 12 folios)"
              className="btn-hard h-8 w-8 shrink-0 border border-[#FFCC00]/50 text-[#FFCC00] flex items-center justify-center hover:bg-[#FFCC00]/10 disabled:opacity-50">
              {placaAiLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />}
            </button>
          )}
          {vozIaActiva && (
            <button type="button" onClick={dictarPlaca} disabled={placaAiLoading} data-testid="placa-voz-btn" title="Dictar la placa por voz (IA · 3 folios)"
              className={`btn-hard h-8 w-8 shrink-0 border flex items-center justify-center disabled:opacity-50 ${escuchandoPlaca ? "bg-[#EF4444] text-white border-[#EF4444] animate-pulse" : "border-[#FFCC00]/50 text-[#FFCC00] hover:bg-[#FFCC00]/10"}`}>
              <Mic className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
      <Input ref={placaInputRef} value={placa} onChange={(e) => setPlaca(e.target.value.toUpperCase())} placeholder="ABC-123" data-testid="placa-input"
        className="h-12 w-full rounded-none bg-white/5 border-white/20 text-white uppercase font-display tracking-wider focus-visible:ring-2 focus-visible:ring-[#FFCC00]" />
      <input ref={placaFileRef} type="file" accept="image/*" capture="environment" onChange={onPlacaFoto} className="hidden" data-testid="placa-foto-input" />
      {placaAiLoading && <p className="text-[11px] text-[#FFCC00] uppercase tracking-wider font-bold" data-testid="placa-ai-loading">Analizando foto con IA…</p>}
      {escuchandoPlaca && <p className="text-[11px] text-[#EF4444] uppercase tracking-wider font-bold">Escuchando… dicta la placa</p>}
    </div>

    {vehiculosDinamicos.length > 0 ? (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="vehiculos-grid">
        {vehiculosDinamicos.map(({ tipo, label, Icon, precio }) => (
          <button key={tipo} onClick={() => generarTicket(tipo)} disabled={generando || lleno} data-testid={`ticket-${tipo.toLowerCase()}`}
            className="btn-hard group bg-white/5 border border-white/20 hover:border-[#FFCC00] hover:bg-[#FFCC00]/5 disabled:opacity-40 disabled:cursor-not-allowed p-6 flex flex-col items-center justify-center gap-2 min-h-[150px] transition-colors duration-200">
            <Icon className="h-12 w-12 text-[#FFCC00]" strokeWidth={1.5} />
            <span className="font-display text-lg font-bold tracking-tight">{label}</span>
            {precio > 0 && <span className="text-[11px] font-bold uppercase tracking-wider text-white/40">${precio.toFixed(2)}</span>}
          </button>
        ))}
      </div>
    ) : hasPorHora ? (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="vehiculos-grid">
        {vehiculosLegacy.map(({ tipo, label, Icon }) => (
          <button key={tipo} onClick={() => generarTicket(tipo)} disabled={generando || lleno} data-testid={`ticket-${tipo.toLowerCase()}`}
            className="btn-hard group bg-white/5 border border-white/20 hover:border-[#FFCC00] hover:bg-[#FFCC00]/5 disabled:opacity-40 disabled:cursor-not-allowed p-6 flex flex-col items-center justify-center gap-3 min-h-[150px] transition-colors duration-200">
            <Icon className="h-12 w-12 text-[#FFCC00]" strokeWidth={1.5} />
            <span className="font-display text-lg font-bold tracking-tight">{label}</span>
          </button>
        ))}
      </div>
    ) : (
      <button onClick={() => generarTicket(null)} disabled={generando || lleno} data-testid="ticket-generar"
        className="btn-hard w-full bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] disabled:opacity-40 p-8 flex items-center justify-center gap-3 font-display text-xl font-black uppercase tracking-wide">
        <TicketIcon className="h-7 w-7" /> Generar ticket de entrada
      </button>
    )}
    {lleno && <p className="mt-4 text-center text-[#EF4444] font-bold uppercase tracking-wider text-sm">Estacionamiento lleno — no se pueden generar tickets</p>}
  </div>
);

export default IngresoVehiculos;
